/**
 * 深色科技风底图（与 smart_city 一致）
 * 通过修改地球表面片元着色器：反色 + RGB 滤镜
 */
export default function modifyMap(viewer) {
  const baseLayer = viewer.imageryLayers.get(0);
  if (!baseLayer) return;

  baseLayer.invertColor = true;
  // [255,255,255] => [0,50,100]，偏青蓝的深色
  baseLayer.filterRGB = [0, 50, 100];

  const surfaceShaderSet = viewer.scene.globe._surfaceShaderSet;
  if (!surfaceShaderSet?.baseFragmentShaderSource?.sources) {
    console.warn("[modifyMap] 无法访问 globe 着色器，深色底图未生效");
    return;
  }

  const sources = surfaceShaderSet.baseFragmentShaderSource.sources;
  const needle =
    "color = czm_saturation(color, textureSaturation);\n#endif\n";

  for (let i = 0; i < sources.length; i++) {
    if (!sources[i].includes(needle)) continue;

    let inject = needle;
    if (baseLayer.invertColor) {
      inject += `
        color.r = 1.0 - color.r;
        color.g = 1.0 - color.g;
        color.b = 1.0 - color.b;
      `;
    }
    if (baseLayer.filterRGB) {
      inject += `
        color.r = color.r * ${baseLayer.filterRGB[0]}.0 / 255.0;
        color.g = color.g * ${baseLayer.filterRGB[1]}.0 / 255.0;
        color.b = color.b * ${baseLayer.filterRGB[2]}.0 / 255.0;
      `;
    }
    sources[i] = sources[i].replace(needle, inject);
  }
}
